import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { UserService } from '../../service/user.service';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MyfireService } from '../../service/myfire.service';
import { StorageService } from '../../service/storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  pacijenti: any = [];
  allRef: any;
  danasRef: any;
  danasPacijenti: any = [];
  pacijentId: string;
  pronadjen: any = [];
  user: any;
  pronadjenPacijent = false;
  nepronadjenPacijent = false;
  today: number = Date.now();
  userRef: firebase.database.Reference;
  users: any = [];
  isLoggedIn: boolean;
  name: any;
  email: any;
  uid: any;
  spec: any;
  isAdmin: any;
  titula: any;
  zavrseni: any = [];
  zavrsiRef: firebase.database.Reference;
  constructor(
    private userService: UserService,
    private location: Location,
    private router: Router,
    private db: MyfireService,
    private storageService: StorageService
  ) {
    this.user = userService.getProfile();
    this.userRef = firebase.database().ref('/users/');
    this.pacijentId = firebase
      .database()
      .ref()
      .child('pacijenti')
      .push().key;
  }
  async TraziPacijenta(form: NgForm) {
    const datumR = form.value.DR;

    this.pronadjen = [];

    await firebase
      .database()
      .ref()
      .child('pacijenti')
      .orderByChild('DatumRodjenja')
      .equalTo(datumR)

      .on('child_added', snapshot => {
        this.pronadjen.push({
          key: snapshot.key,
          data: snapshot.val()
        });

        this.pronadjenPacijent = true;
      });
    setTimeout(() => {
      if (this.pronadjen.length === 0) {
        this.nepronadjenPacijent = true;
        this.pronadjenPacijent = false;
      } else {
        this.nepronadjenPacijent = false;
        this.pronadjenPacijent = true;
      }
    }, 1000);
  }
  obrisiDanas(ind, naplata, key, uid) {
    if (!naplata) {
      alert('Polje Naplata je obavezno!');
      return;
    }
    if (naplata < 0) {
      alert('Polje Naplata ne sme biti negativno!');
      return;
    } else {
      if (confirm('Da li ste sigurni da želite da završite?')) {
        this.zavrseni.splice(ind, 1);
        firebase
          .database()
          .ref('danas/' + uid)
          .remove();
        firebase
          .database()
          .ref('zavrsi/' + key)
          .remove();
      }
    }
  }
  dodajDanas(ime, prezime, datum, id, doktor) {
    const Ime = ime;
    const Prezime = prezime;
    const Datum = datum;
    const pacijentKey = id;
    const doktorSelect = doktor.value;

    firebase
      .database()
      .ref('danas/' + pacijentKey)
      .set({
        Ime: Ime,
        Prezime: Prezime,
        DatumRodjenja: Datum,
        path: `pacijent/${pacijentKey}`,
        DatumUbacivanja: this.today,
        doktor: doktorSelect
      });
    this.closePretragu();
  }
  closePretragu() {
    this.pronadjenPacijent = false;
  }
  naplataPacijentu(naplata: Number, doktor: any, datum, key) {
    if (!naplata) {
      alert('Polje Naplata je obavezno!');
      return;
    }
    if (naplata < 0) {
      alert('Polje Naplata ne sme biti negativno!');
      return;
    }
    this.storageService.createNaplata(naplata, doktor, datum, key);
    firebase
      .database()
      .ref('naplataDr/')
      .child(doktor)
      .child(key)
      .set({ naplata, datum });
  }
  ngOnInit() {
    this.userService.statusChange.subscribe(userData => {
      if (userData) {
        this.name = userData.name;
        this.email = userData.email;
        this.uid = userData.uid;
        this.spec = userData.spec;
        this.isAdmin = userData.isAdmin;
        this.titula = userData.titula;
      } else {
        this.name = null;
        this.email = null;
        this.uid = null;
        this.spec = null;
        this.isAdmin = false;
        this.titula = null;
      }
    });

    firebase.auth().onAuthStateChanged(userData => {
      if (userData) {
        this.isLoggedIn = true;

        const user = this.userService.getProfile(); //kad se refreshuje ako ima usera ovo radi. Pri prvom ulazku ide ono gore
        if (user && user.name) {
          this.name = user.name;
          this.email = user.email;
          this.uid = user.uid;
          this.spec = user.spec;
          this.isAdmin = user.isAdmin;
          this.titula = user.titula;
        }
        this.router.navigate(['/']);
      } else {
        this.isLoggedIn = false;

        this.router.navigate(['/login']);
      }
    });

    this.userRef.on('child_added', data => {
      this.users.push({
        key: data.key,
        data: data.val()
      });
    });
    this.allRef = firebase
      .database()
      .ref()
      .child('pacijenti');

    this.danasRef = firebase.database().ref('danas');
    this.zavrsiRef = firebase.database().ref('zavrsi');

    this.allRef.limitToLast(50).on('child_added', data => {
      this.pacijenti.push({
        key: data.key,
        data: data.val()
      });
      this.pacijenti.sort(
        (a, b) => b.data.DatumUbacivanja - a.data.DatumUbacivanja
      );
    });
    this.danasRef.on('child_added', data => {
      this.danasPacijenti.push({
        key: data.key,
        data: data.val()
      });

      this.danasPacijenti.sort(
        (a, b) => b.data.DatumUbacivanja - a.data.DatumUbacivanja
      );
    });
    this.zavrsiRef.on('child_added', data => {
      this.zavrseni.push({
        key: data.key,
        data: data.val()
      });

      this.zavrseni.sort(
        (a, b) => b.data.DatumUbacivanja - a.data.DatumUbacivanja
      );
    });
  }
}
